module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-hh.0ee9c340.png";